import { Collection, MaxString, ModelBase, NormalString, ObservableCollection, Property, Range, Required, VeryLongString, VeryShortString } from '@skylab-shared/core';
import { AddressModel } from '../address/address.model';
import { CustomFlags } from '../common/custom-flags';
import { ClientBankAccountModel } from './client-bank-account.model';
import { ClientKind } from './client-kind';
import { ClientOtherBuyerRole } from './client-other-buyer-role';
import { TinKind } from './tax-identification-numer-kind';

export class ClientModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    public kind: ClientKind;

    @Property()
    public tinKind: TinKind;

    @Property()
    @VeryShortString('data-model.client.validation.tin.length')
    public tin: string;

    public get normalizedTin(): string {
        return this.tin.replace(/[\s\-]+/g, '');
    }

    @Property()
    @VeryLongString('data-model.client.validation.name.length')
    @Required('data-model.client.validation.name.non-empty')
    public name: string;

    @Property()
    public associatedClient: boolean;

    @Property()
    @VeryLongString('data-model.client.validation.address.length')
    public address: string;

    @Property()
    @NormalString('data-model.client.validation.city.length')
    public city: string;

    @Property()
    @VeryShortString('data-model.client.validation.zip-code.length')
    public zipCode: string;

    @Property(AddressModel, { nullable: true })
    public deliveryAddress: AddressModel | null;

    @Collection({ type: ClientBankAccountModel })
    public bankAccounts: ObservableCollection<ClientBankAccountModel>;

    @Property()
    @MaxString('data-model.client.validation.note.length')
    public note: string;

    @Property()
    public emails: string[];

    @Property()
    @VeryLongString('data-model.client.validation.email.length')
    public clientEmailsPlainText: string;

    @Property()
    @VeryLongString('data-model.client.validation.website.length')
    public website: string;

    @Property(String, {nullable: true})
    public internalIdentificationNumber: string | null;

    @Property()
    @VeryLongString('data-model.client.validation.phone.length')
    public phone1: string;

    @Property()
    @VeryLongString('data-model.client.validation.phone.length')
    public phone2: string;

    @Property()
    @VeryLongString('data-model.client.validation.communicator.length')
    public skype: string;

    @Property(Number, { nullable: true })
    public buyerId: number | null;

    @Property(String, {nullable: true})
    public buyerRole: ClientOtherBuyerRole | null;

    @Property(String, { nullable: true })
    public clientGroupId: string | null;

    @Property(Number, { nullable: true })
    public countryId: number | null;

    @Property()
    public customFlags: CustomFlags;

    @Property({ nullable: true })
    public defaultDiscount?: number;

    @Property({ nullable: true })
    public defaultPaymentMethodId?: number;

    @Property(Number, { nullable: true })
    @Range({ min: 0, max: 999 }, 'data-model.client.validation.default-due-date.length')
    public defaultDueDate: number | null;

    @Property()
    public favourite: boolean;
}
